// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { addPartnerToWhitelistRequestToJson, batchGetFeatureFlagRequestToJson, batchGetFeatureFlagResponseFromJson, batchGetStatusFeatureFlagRequestToJson, batchGetStatusFeatureFlagResponseFromJson, createAnalyticsDashboardRequestToJson, createFeatureFlagRequestToJson, listFeatureFlagRequestToJson, listFeatureFlagResponseFromJson, updateFeatureFlagRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function create(request) {
    await fetchRpc('partner.v1.FeatureFlags/Create', createFeatureFlagRequestToJson(request));
}
export function create$(request, options) {
    return defer(() => createWithTransport$(getGlobalTransport(), request, options));
}
export function createWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.FeatureFlags/Create', createFeatureFlagRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function update(request) {
    await fetchRpc('partner.v1.FeatureFlags/Update', updateFeatureFlagRequestToJson(request));
}
export function update$(request, options) {
    return defer(() => updateWithTransport$(getGlobalTransport(), request, options));
}
export function updateWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.FeatureFlags/Update', updateFeatureFlagRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function batchGetStatus(request) {
    const raw = await fetchRpc('partner.v1.FeatureFlags/BatchGetStatus', batchGetStatusFeatureFlagRequestToJson(request));
    return batchGetStatusFeatureFlagResponseFromJson(raw);
}
export function batchGetStatus$(request, options) {
    return defer(() => batchGetStatusWithTransport$(getGlobalTransport(), request, options));
}
export function batchGetStatusWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.FeatureFlags/BatchGetStatus', batchGetStatusFeatureFlagRequestToJson(request), options)
        .pipe(map(resp => batchGetStatusFeatureFlagResponseFromJson(resp)));
}
export async function batchGet(request) {
    const raw = await fetchRpc('partner.v1.FeatureFlags/BatchGet', batchGetFeatureFlagRequestToJson(request));
    return batchGetFeatureFlagResponseFromJson(raw);
}
export function batchGet$(request, options) {
    return defer(() => batchGetWithTransport$(getGlobalTransport(), request, options));
}
export function batchGetWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.FeatureFlags/BatchGet', batchGetFeatureFlagRequestToJson(request), options)
        .pipe(map(resp => batchGetFeatureFlagResponseFromJson(resp)));
}
export async function list(request) {
    const raw = await fetchRpc('partner.v1.FeatureFlags/List', listFeatureFlagRequestToJson(request));
    return listFeatureFlagResponseFromJson(raw);
}
export function list$(request, options) {
    return defer(() => listWithTransport$(getGlobalTransport(), request, options));
}
export function listWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.FeatureFlags/List', listFeatureFlagRequestToJson(request), options)
        .pipe(map(resp => listFeatureFlagResponseFromJson(resp)));
}
export async function createAnalyticsDashboard(request) {
    await fetchRpc('partner.v1.FeatureFlags/CreateAnalyticsDashboard', createAnalyticsDashboardRequestToJson(request));
}
export function createAnalyticsDashboard$(request, options) {
    return defer(() => createAnalyticsDashboardWithTransport$(getGlobalTransport(), request, options));
}
export function createAnalyticsDashboardWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.FeatureFlags/CreateAnalyticsDashboard', createAnalyticsDashboardRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function addPartnerToWhitelist(request) {
    await fetchRpc('partner.v1.FeatureFlags/AddPartnerToWhitelist', addPartnerToWhitelistRequestToJson(request));
}
export function addPartnerToWhitelist$(request, options) {
    return defer(() => addPartnerToWhitelistWithTransport$(getGlobalTransport(), request, options));
}
export function addPartnerToWhitelistWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.FeatureFlags/AddPartnerToWhitelist', addPartnerToWhitelistRequestToJson(request), options)
        .pipe(map(() => undefined));
}
